let loading=null,failed=false,lastScript=null,restoreAuth=null,forceReload=false,attempt=0;
const failureListeners=new Set();
export function onGoogleMapFailure(listener){failureListeners.add(listener);if(failed)listener();return()=>{failureListeners.delete(listener);};}
// Only an explicit retry clears an authorization failure. A stale SDK object
// must not turn that retry into an immediate, misleading success.
export function resetGoogleMapFailure(){
 if(!failed)return;
 restoreAuth?.();lastScript?.remove();loading=null;failed=false;forceReload=true;
}

// A single SDK script per page, even with several visible map components.
// API keys stay in ignored local configuration, with API/referrer restrictions.
export function loadGoogleMaps(key,locale='da-DK'){
 if(!key)return Promise.reject(new Error('maps_not_configured'));
 if(failed)return Promise.reject(new Error('maps_auth_failed'));
 if(loading)return loading;
 if(!forceReload&&window.google?.maps?.Map)return Promise.resolve(window.google.maps);
 loading=new Promise((resolve,reject)=>{
  const script=document.createElement('script'),callback='__qtrackerGoogleMapsReady'+(++attempt);
  lastScript=script;
  let complete=false;
  const timer=setTimeout(()=>error('maps_timeout'),20000);
  const error=code=>{if(complete)return;complete=true;clearTimeout(timer);script.remove();delete window[callback];if(code!=='maps_auth_failed')restoreAuth();loading=null;reject(new Error(code));};
  const previous=window.gm_authFailure;
  const authFailure=()=>{failed=true;error('maps_auth_failed');for(const listener of failureListeners)listener();if(previous)previous();};
  window.gm_authFailure=authFailure;
  restoreAuth=()=>{if(window.gm_authFailure===authFailure)window.gm_authFailure=previous;};
  window[callback]=()=>{if(complete)return;complete=true;forceReload=false;clearTimeout(timer);delete window[callback];resolve(window.google.maps);};
  script.async=true;script.onerror=()=>error('maps_network_failed');
  script.src='https://maps.googleapis.com/maps/api/js?'+new URLSearchParams({key,v:'quarterly',loading:'async',callback,language:locale==='da-DK'?'da':'en',region:'DK'});
  const nonce=document.querySelector('script[nonce]')?.nonce;if(nonce)script.nonce=nonce;
  document.head.append(script);
 });
 return loading;
}
